/* eslint-disable no-template-curly-in-string */
/**
 * Completed Survey Card
 */

import {
  Flex,
  Heading,
  HStack,
  Text,
  Link as ChakraLink,
  Tooltip,
} from "@chakra-ui/react";
import useAuth from "hooks/useAuth";
import { SurveyCompleteIcon } from "../../base/atoms/HJSIcons";
import { useMemo } from "react";

type TSurveyCard = ({
  surveyIdentifier,
  survey,
}: {
  surveyIdentifier: string;
  survey: any;
}) => JSX.Element;

const CompletedSurveyCard: TSurveyCard = ({
  surveyIdentifier,
  survey,
}: {
  surveyIdentifier: string;
  survey: any;
}) => {
  const { userDetails } = useAuth();
  const {
    completeSms,
    earnedSmsAmount,
    totalSms,
    reward,
    earnedCompensation,
  }: { [key: string]: string } = survey;
  const numericEarnedCompensation = Number(earnedCompensation);
  const numericEarnedSmsAmount = Number(earnedSmsAmount);

  const toolTipLabel1 = useMemo(() => {
    const title = survey?.title?.toUpperCase();
    switch (title) {
      case "PERSONALITY SURVEY":
        return `You earned $${earnedCompensation} for responding to this survey. We'll process your check as soon as possible. Please allow 14 business days for the check to arrive in the mail.`;
      // case "FOLLOW-UP 1 SURVEY":
      //   return "You earned ${{earnedSMSAmount1}} for responding to {{completedSMS1}} out of {{totalSMS1}} text message surveys plus ${{earnedAmountFollowUp1}} for responding to the survey online. Please allow 14 business days for your check to arrive in the mail.";
      // case "FOLLOW-UP 2 SURVEY":
      //   return "You earned ${{earnedSMSAmount2}} for responding to {{completedSMS2}} out of {{totalSMS2}} text message surveys plus ${{earnedAmountFollowUp2}} for responding to the survey online. Please allow 14 business days for your check to arrive in the mail.";
      // case "FOLLOW-UP 3 SURVEY":
      //   return "You earned ${{earnedSMSAmount3}} for responding to {{completedSMS3}} out of {{totalSMS3}} text message surveys plus ${{earnedAmountFollowUp3}} for responding to the survey online. Please allow 14 business days for your check to arrive in the mail.";
      default:
        return `You earned $${earnedSmsAmount} for responding to ${completeSms} out of ${totalSms} text message surveys plus $${
          numericEarnedCompensation - numericEarnedSmsAmount
        } for responding to the survey online. Please allow 14 business days for your check to arrive in the mail.`;
    }
  }, [survey?.title]);

  const tooltipLabel =
    surveyIdentifier === "personality"
      ? "You earned $20 for completing this survey. Please allow 14 business days for your check to arrive in the mail."
      : surveyIdentifier === "followUp1"
      ? `You earned $25 for completing this survey. Please allow 14 business days for your check to arrive in the mail.`
      : "You earned $35 for completing this survey. Please allow 14 business days for your check to arrive in the mail.";

  return (
    <ChakraLink
      w="full"
      // as={Link}
      // to={`/survey/${surveyIdentifier}`}
      className={`${
        (userDetails?.isEligible as boolean) ? "" : "disable-link"
      }`}
      _hover={{ textDecor: "none", shadow: "lg" }}
      mt={12}
    >
      <Flex flexDir="column" overflow="hidden">
        <Flex
          px={[4, 3, 10]}
          py={[4, 5, 6]}
          borderRadius="8px"
          bgColor="hjsSurveyComplete"
          justifyContent="space-between"
        >
          <HStack>
            <SurveyCompleteIcon fill="none" boxSize={6} />
            <Heading
              as="h2"
              fontSize={[16, 16, 20, "1.5rem"]}
              color="teal.900"
              textTransform="capitalize"
            >
              {`${survey.title as string} completed`}
            </Heading>
          </HStack>

          <Tooltip
            label={
              userDetails?.layer === 2 || userDetails === null
                ? tooltipLabel
                : toolTipLabel1
            }
            placement="top-start"
          >
            <Text color="white" fontWeight="700" fontSize={[16, 16, 20]}>
              $
              {`${survey.earnedCompensation as string} / $${
                survey.maxSurveyCompensation as string
              }`}
            </Text>
          </Tooltip>
        </Flex>
      </Flex>
    </ChakraLink>
  );
};

export default CompletedSurveyCard;
